import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import { getUrlParams } from './util';
import { getCookie } from './cookies';
var wxJsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo', 'scanQRCode', 'chooseImage', 'uploadImage', 'previewImage', 'getLocation', 'openLocation', 'launchApplication', 'getInstallState', 'openBusinessView'];
var wxWorkJsApiList = wxJsApiList.concat('getLocalImgData', 'downloadImage');
export var wxAuth = function wxAuth(conf, options) {
  var wxwork = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var config = _objectSpread({}, options);
  conf = {
    debug: config.debug || false,
    appId: conf.appId,
    timestamp: conf.timestamp,
    nonceStr: conf.noncestr,
    signature: conf.signature,
    jsApiList: wxJsApiList
  };
  // 企业微信特殊处理
  wxwork && (conf.beta = true, conf.jsApiList = wxWorkJsApiList);
  window.wx.config(conf);
  window.wx.error(function (res) {
    console.error('微信配置失败', res);
  });
};
export var getWxPublicId = function getWxPublicId(obj) {
  var query = getUrlParams();
  var config = _objectSpread({}, window.nativeAdapterConfig);
  if (obj && obj.isWa) {
    return query.wxPublicId || config.wxPublicId || '24';
  }
  return query.wxPublicId || config.wxPublicId || query.__t || getCookie('zz_t') || getCookie('t') || '24';
};